var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{attrs:{"label":_vm.labelV,"rules":_vm.rules,"color":_vm.color,"dense":""},model:{value:(_vm.checkbox),callback:function ($$v) {_vm.checkbox=$$v},expression:"checkbox"}})}
var staticRenderFns = []

export { render, staticRenderFns }